import api from "../services/api";

import { IDynamicModelRequest, IDynamicModelResponse } from "../interfaces";

class DynamicRepository {

    public DynamicTotals = async (dynamicRequest: IDynamicModelRequest[]): Promise<IDynamicModelResponse> => {

        const dynamicParam = JSON.stringify(dynamicRequest);

        const response = await api.get<IDynamicModelResponse>("totaldinamico", {
            params: {
                dynamicmodel: dynamicParam,
            }
        });

        return response.data;
    }
}

const dynamicRepository = new DynamicRepository();
export default dynamicRepository;



